import { Dispatch } from 'react';
import axios, { Method } from 'axios';
import Cookies from 'js-cookie';
import { IAction, Selection } from '../interfaces/interfaces';
import { saveToCache } from '../helpers/shared';
import {
    SET_SELECTION_VALUE,
    SET_FIELD_VALIDATION,
    RESET,
    SET_SELECTION_VALUES,
    SET_FIELD_VALIDATIONS
} from '../store/ActionKeys';

export type Endpoint = {
    method: Method;
    url: string;
    headers: { [key: string]: string | number } | undefined;
    timeout?: number;
};

type Payload = {
    key: string;
    value: unknown;
};

export const genericRequest = async ({ method, url, headers, timeout }: Endpoint, payload?: unknown) => {
    // if axios.request fails, the promise will reject; how to get the error details is non-obvious, but possible
    const { data } = await axios.request({ method, url, headers, timeout, data: payload });
    return data;
};

export const setSelectionValue = (
    dispatch: Dispatch<IAction>,
    selection: Selection,
    data: Payload,
    updateCache: boolean = false
) => {
    if (updateCache) {
        saveToCache({ selection: { ...selection, [data.key]: data.value } });
    }

    // store value
    dispatch({
        type: SET_SELECTION_VALUE,
        payload: { key: data.key, value: data.value }
    });
};

export const setSelectionValues = (
    dispatch: Dispatch<IAction>,
    selection: Selection,
    data: Partial<Selection>,
    updateCache: boolean = false
) => {
    if (updateCache) {
        saveToCache({ selection: { ...selection, ...data } });
    }

    // store value
    dispatch({
        type: SET_SELECTION_VALUES,
        payload: data
    });
};

export const setFieldValidation = (dispatch: Dispatch<IAction>, fieldKey: string, valid: boolean) => {
    dispatch({
        type: SET_FIELD_VALIDATION,
        payload: {
            fieldKey,
            valid
        }
    });
};

export const setFieldValidations = (
    dispatch: Dispatch<IAction>,
    fieldValidation: Record<string, boolean | undefined>,
    data: Record<string, boolean | undefined>,
    updateCache: boolean = false
) => {
    if (updateCache) {
        saveToCache({ fieldValidation: { ...fieldValidation, ...data } });
    }
    dispatch({
        type: SET_FIELD_VALIDATIONS,
        payload: data
    });
};

export const reset = (dispatch: Dispatch<IAction>, removeJwt: boolean = true) => {
    sessionStorage.removeItem('selection');
    sessionStorage.removeItem('model');

    if (removeJwt) {
        Cookies.remove('jwt');
    }

    dispatch({
        type: RESET,
        payload: {}
    });
};
